export default __webpack_public_path__ + "static/media/ipad_mockup3.dad77014.png";